import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-busca-redime-vive',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './busca-redime-vive.component.html',
  styleUrl: './busca-redime-vive.component.scss'
})
export class BuscaRedimeViveComponent {}
